/**
 * SEO 相关的关键 DOM 选择器
 */
const CANONICAL_SELECTOR = 'link[rel="canonical"]' // 用于告诉搜索引擎该页面的唯一标准链接，防止重复内容权重分散
const OG_URL_SELECTOR = 'meta[property="og:url"]' // Open Graph 协议标签，用于社交媒体（如 Facebook, Twitter）分享时识别页面主体链接

/**
 * 确保 head 中存在指定的元素，如果不存在则调用工厂函数创建并插入
 * @param {string} selector - CSS 选择器
 * @param {Function} createElement - 创建新元素的工厂函数
 * @returns {HTMLElement} 返回找到或新创建的 DOM 元素
 */
const ensureHeadElement = (selector, createElement) => {
  let element = document.head.querySelector(selector)

  if (!element) {
    element = createElement()
    document.head.appendChild(element)
  }

  return element
}

/**
 * 获取当前页面在运行时的完整 SEO URL（包含 protocol, host, path 和 search）
 * @returns {string} 完整的绝对路径 URL
 */
const getRuntimeSeoUrl = () => `${window.location.origin}${window.location.pathname}${window.location.search}`

/**
 * 动态更新当前页面的运行时 SEO 链接
 * 在 SPA 路由切换后调用（router.afterEach），解决单页应用页面内容变了但 head 静态标签不变的问题
 */
export const updateRuntimeSeoUrl = () => {
  // 非浏览器环境（如 SSR 或构建环境）直接跳过
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  const seoUrl = getRuntimeSeoUrl()

  // 1. 更新 Canonical 标签：这对于 SEO 非常关键，它告诉爬虫在 /en_us/home?a=1 下，核心内容归属于当前路径
  const canonicalLink = ensureHeadElement(CANONICAL_SELECTOR, () => {
    const link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    return link
  })
  canonicalLink.setAttribute('href', seoUrl)

  // 2. 更新 og:url 标签：确保社交媒体分享出去的链接包含了当前的语言前缀和参数
  const ogUrlMeta = ensureHeadElement(OG_URL_SELECTOR, () => {
    const meta = document.createElement('meta')
    meta.setAttribute('property', 'og:url')
    return meta
  })
  ogUrlMeta.setAttribute('content', seoUrl)
}
